export default __webpack_public_path__ + "static/media/service-products.8f695591.svg";